import React, { useState, useRef, useEffect } from "react";
import { useLocation, useHistory } from "react-router";
import { Link } from "react-router-dom";
import { exportComponentAsPNG } from "react-component-export-image";
import logo from "../../../images/logo.svg";
import oneforceBg from "../../../images/oneforce-template-meme-white.png"; // We'll use a placeholder if this doesn't exist
import "../../../styles/career-fair-one.css";
import "../../../styles/template.css";
import UploadImgMain from "./UploadImg";

// OneForce specific implementation
export const MemeComponent = React.forwardRef((props, ref) => {
  return (
    <div ref={ref} className="mainExport">
      <div className="meme-content">
        <img src={oneforceBg} alt="" className="imgPreview" />
        {props.img && (
          <div className="uploaded-image-container">
            <img src={props.img} alt="" className="uploaded-image" />
          </div>
        )}
      </div>
    </div>
  );
});

const OneForce = (props) => {
  const history = useHistory();
  const memeRef = useRef();
  const location = useLocation();

  const [imgPreview, setImgPreview] = useState(null);
  const [modal, setModal] = useState("close");

  const uploadImgModal = () => {
    setModal("open");
  };
  const previewModal = () => {
    setModal("preview");
  };
  const closeModal = () => {
    setModal("close");
  };

  const handleCroppedImage = (croppedImage) => {
    setImgPreview(croppedImage);
    closeModal();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      {modal === "open" && (
        <UploadImgMain 
          closeModal={closeModal} 
          previewModal={previewModal}
          onImageCropped={handleCroppedImage}
        />
      )}
      <div className="h-screen flex template-main">
        <div className="actions p-8">
          <Link to="/">
            <img src={logo} alt="logo" className="h-10 w-10 rounded-full" />
          </Link>
          <div className="btns my-10 space-y-4">
            <button className="upload" onClick={uploadImgModal}>
              Upload Photo
            </button>
            <button className="change-template" onClick={history.goBack}>
              Change Template
            </button>
          </div>
        </div>
        <div className="main p-4">
          <MemeComponent ref={memeRef} img={imgPreview} />
          <div
            className="memeBtns flex mt-4 w-full space-x-4 justify-between h-12"
            style={{ fontFamily: "Museo300" }}
          >
            <button
              className="w-full bg-green-500 rounded h-full font-bold text-white"
              onClick={uploadImgModal}
            >
              Select Photo
            </button>
            <button
              className="change-template w-full rounded h-full font-bold"
              onClick={history.goBack}
            >
              Change Template
            </button>
          </div>
          <button
            className="meme-download"
            onClick={() =>
              exportComponentAsPNG(memeRef, { fileName: "OneForce" })
            }
          >
            Download Meme
          </button>
        </div>
      </div>
    </>
  );
};

export default OneForce; 